import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

import { MessageService } from 'primeng/components/common/messageservice';

import { AcoesService } from '../../acoes/acoes.service';
import { FormUtil } from '../../base/util/form.util';
import { Field } from '../../base/vo/formulario';
import { Gto } from '../../base/vo/gto';
import { JustificativaToken } from '../../base/vo/justificativa-token';
import { SalvaTokenGto } from '../../base/vo/salva-token-gto';
import { GtoTokenService } from '../gto-token.service';


@Component({
  providers: [DatePipe],
  selector: 'app-without-token',
  templateUrl: './without-token.component.html',
  styleUrls: ['./without-token.component.scss']
})
export class WithoutTokenComponent implements OnInit, OnDestroy {

  @Input() gto: Gto;

  @Output() readonly stepEmitter: EventEmitter<number> = new EventEmitter();

  private subs: Subscription[] = [];

  public formGroup: FormGroup;
  public justificatinonList: JustificativaToken[] = [];
  public loading = false;
  public loadingJustificativas = true;

  public fields: Field[] = [
    {
      controlName: 'justificativa',
      label: 'Selecione um motivo',
      options: [],
    },
  ];

  constructor(
    private readonly acoesService: AcoesService,
    private readonly datePipe: DatePipe,
    private readonly formBuilder: FormBuilder,
    private readonly gtoTokenService: GtoTokenService,
    private readonly messageService: MessageService,
    private readonly router: Router,
  ) { }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      justificativa: ['', [Validators.required]],
    });

    this.getListaJustificativas();
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  private setFields() {
    this.fields[0].options = this.justificatinonList.map(justificativa => {
      return {
        id: justificativa.codigo.toString(),
        name: justificativa.nome,
        value: justificativa.codigo.toString(),
      };
    });
  }

  private getListaJustificativas() {
    this.loadingJustificativas = true;

    this.subs.push(this.gtoTokenService.getListaJustificativas().pipe(
      tap(response => {
        this.justificatinonList = response.data;
        this.setFields();
        this.loadingJustificativas = false;
      },
        errorResponse => {
          this.messageService.add({
            severity: 'error', summary: 'Erro ao carregar lista de justificativas.',
            detail: errorResponse.error.errors[0].message
          });
          this.changeStep(0);
        })
    ).subscribe());
  }

  private justify() {
    this.loading = true;

    const salvaTokenGto: SalvaTokenGto = {
      codigoJustificativa: this.formGroup.controls.justificativa.value.value,
      codigoPrestador: +this.gto.codigoPrestadorExecutante,
      dataToken: this.datePipe.transform(new Date(), 'dd/MM/yyyy'),
      idToken: this.gto.idToken,
      numeroGTO: +this.gto.numero,
    };

    this.subs.push(this.gtoTokenService.salvarJustificativa(salvaTokenGto).pipe(
      tap(_ => {
        this.loading = false;
        this.acoesService.setCanGoToFinalizar(true);
        this.gtoTokenService.setCanOpenModalTokenOnFinalizar(true);
        this.router.navigate([`detalhagto/${this.gto.numero}/finalizar`]);
      },
        errorResponse => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Erro ao justificar.', detail: errorResponse.error.errors[0].message });
          this.changeStep(0);
        }),
    ).subscribe());

  }

  public submit() {
    FormUtil.checkFormValidations(this.formGroup);
    if (this.formGroup.valid) {
      this.justify();
    }
  }

  public changeStep(step: number) {
    this.stepEmitter.emit(step);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/gto-token/without-token/without-token.component.ts